import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Button, Typography } from '@material-ui/core'
import { Link } from 'react-router-dom'
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined'

export default function CompleteCard({ count, handleCountClick }) {
  const useStyles = makeStyles(theme => ({
    root: {
      margin: '0 2em'
    },
    button: {
      margin: '0em 0 2em',
      width: '100%'
    },
    [theme.breakpoints.down('xs')]: {
      button: {
        margin: count === 1 ? '2em 0 2em' : '0em 0 2em'
      }
    },
    signin: {
      color: 'black',
      textAlign: 'center',
      margin: '1.5em 0',
      fontSize: '0.875rem',
      fontWeight: 600
    }
  }))
  const classes = useStyles()
  return (
    <div className="success-logo">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="200"
        height="200"
        viewBox="0 0 221.511 221.511">
        <g
          id="Layer_2"
          data-name="Layer 2"
          transform="translate(-527.84 -295.91)">
          <g
            id="outline_III"
            data-name="outline III"
            transform="translate(530.84 298.91)">
            <g id="message_sent" data-name="message sent">
              <g id="icon">
                <circle
                  id="Ellipse_122"
                  data-name="Ellipse 122"
                  cx="107.756"
                  cy="107.756"
                  r="107.756"
                  fill="none"
                  stroke="#2e186a"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="6"
                />
                <path
                  id="succes_icon"
                  data-name="succes icon"
                  d="M730.466,304.908a9.561,9.561,0,0,0-13.161,3.077L693.76,345.8A81.534,81.534,0,1,0,707.5,359.9l26.029-41.828A9.553,9.553,0,0,0,730.466,304.908ZM718.159,409.257a75.534,75.534,0,1,1-27.6-58.3l-42.613,68.5-24.676-32.829A9.572,9.572,0,0,0,607.949,398.1l33.075,43.982a9.538,9.538,0,0,0,7.638,3.808h.415a9.538,9.538,0,0,0,7.692-4.492l47.328-75.98a74.988,74.988,0,0,1,14.061,43.844Z"
                  transform="translate(-537.83 -299.963)"
                  fill="#fe7624"
                />
              </g>
              ``
            </g>
          </g>
        </g>
      </svg>
      <Typography variant="h4" style={{ margin: '2em 0 .5em' }}>
        Thank You
      </Typography>
      <Typography variant="h1">Registration Complete!</Typography>
      <Typography variant="body1" style={{ color: 'red', marginTop: '1em' }}>
        Please wait until your account get verified... This process may take few
        Hours
      </Typography>
      <Button
        className={classes.button}
        style={{ maxWidth: '23em' }}
        onClick={() => handleCountClick()}
        variant="contained"
        color="primary"
        disableElevation
        component={Link}
        to="/dashboard"
        startIcon={<CheckOutlinedIcon />}>
        Finish
      </Button>
    </div>
  )
}
